// extracted by mini-css-extract-plugin
module.exports = {"header":"_19482","back":"_4951","shareIcon":"_1535"};